<template>
    <dash
        icon="fa fa-book"
        titulo="CONTRATAÇÕES SGF"
        @click.native="$router.push({ name: 'Uabs_Contratacoes' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
